module.exports = __webpack_public_path__ + "img/contribute-icon.eb4f7b90.png";